import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

const pathApi = 'Dominio';

@Injectable({
  providedIn: 'root',
})
export class DominioService {

  constructor(private http: HttpClient) { }

  getCompanys(): Observable<any> {
    return this.http.get<any>(`${environment.URL_API}/${pathApi}/GetCompanies`);
  }
}